import { QueryClient } from "react-query";

/**
 * @deprecated Not assigned or used because of lack of testing. Curently using default QueryClient settings.
 * @type {import("react-query").QueryClientConfig}
 */
// eslint-disable-next-line no-unused-vars
const queryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: (failureCount, error) => {
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: 1,
      retryDelay: 1000,
      onError: (error, variables, context) => {
        console.error("Mutation failed:", error);

        if (process.env.NODE_ENV === "development") {
          console.warn("Mutation variables:", variables);
          console.warn("Mutation context:", context);
        }
      },
    },
  },
};

export const createQueryClient = () => new QueryClient(queryClientConfig);

/** @type {QueryClient | null} */
let queryClientInstance;

export const getQueryClient = () => {
  if (!queryClientInstance) {
    queryClientInstance = createQueryClient();
  }
  return queryClientInstance;
};

export const resetQueryClient = () => {
  if (queryClientInstance) {
    queryClientInstance.clear();
    queryClientInstance = null;
  }
  queryClientInstance = createQueryClient();
  return queryClientInstance;
};

export const debugQueryClient = (client) => {
  if (process.env.NODE_ENV === "development") {
    window.__REACT_QUERY_CLIENT__ = client;
    console.log("QueryClient attached to window.__REACT_QUERY_CLIENT__ for debugging");
  }
};
